import { SpaceBetween } from "@cloudscape-design/components-themed";

import { Main } from "../components/settlement-state-change-application/Main";
import { PERMISSIONS } from "../configs/constants";
import { useAuthenticationHook } from "../app/useAuthenticationHook";

/*
決済状態変更申請
 */
const SettlementStateChangeApplication = () => {
  //権限制御
  useAuthenticationHook(PERMISSIONS.INDIVIDUAL_COUNSELING);

  return (
    <SpaceBetween size="l">
      <Main />
    </SpaceBetween>
  );
};

export default SettlementStateChangeApplication;

